/*
 * OpenAliaPopup
 *
 * Usage:
 *   <open-alia-popup data-campaign-id="266235">
 *     <button type="button">Open popup</button>
 *   </open-alia-popup>
 *
 * Attributes:
 *   data-campaign-id   (required) Alia campaign ID — visible in gray next to the campaign name.
 *   data-ignore-targeting  (optional) Set to "false" to respect Alia's targeting rules.
 *                          Defaults to true (always opens when the button is clicked).
 */

class OpenAliaPopup extends HTMLElement {
  connectedCallback() {
    const button = this.querySelector("button");

    if (!button) {
      console.error("<open-alia-popup> requires a <button> child element.");
      return;
    }

    button.addEventListener("click", () => this.#open());
  }

  #open() {
    const campaignID = parseInt(this.dataset.campaignId, 10);

    if (!campaignID) {
      console.error("<open-alia-popup> is missing a valid data-campaign-id attribute.");
      return;
    }

    const ignoreTargeting = this.dataset.ignoreTargeting !== "false";

    window.alia = window.alia || [];
    window.alia.push({ type: "open", campaignID, ignoreTargeting });
  }
}

customElements.define("open-alia-popup", OpenAliaPopup);
